import nemaLogo from '../img/nemalogo1Asset2.png'
import clientConfig from '../../../ClientConfig'
import { useSelector } from 'react-redux'

const HeaderPdf = () => {
  const { user } = useSelector((state) => state.auth)

  return (
    <header className='pdf-header'>
      <div className='position-relative'>
        <a href='https://nemaai.com/'>
          <img src={nemaLogo} alt='brand-logo' className='white-logo-svg' />
        </a>
        <span className='position-absolute top-0 end-0 text-white'>&trade;</span>
      </div>
      {clientConfig?.[user.name]?.logo && (
        <div className=' d-flex flex-column align-items-end'>
          <a href={clientConfig[user.name].website}>
            <img src={clientConfig[user.name].logo} alt='brand-logo' className='white-logo-svg' />
          </a>
        </div>
      )}
    </header>
  )
}
export default HeaderPdf
